import { card } from "@universityofmaryland/web-elements-library/composite";
import { events } from "@universityofmaryland/web-elements-library/atomic";
import { createTextWithLink, createTextContainer, createImageOrLinkedImage } from "@universityofmaryland/web-utilities-library/elements";
const eventsDisplayStrategy = {
  layoutType: "grid",
  mapEntryToCard: (entry, options) => {
    const {
      isThemeDark = false,
      isTransparent = false,
      isAligned = false,
      imageConfig,
      cardType = "block"
    } = options;
    const headline = createTextWithLink({
      text: entry.title,
      url: entry.url
    });
    const text = createTextContainer({
      text: entry.summary,
      allowHTML: true
    });
    const eventMeta = events.meta({
      ...entry,
      isThemeDark
    });
    const imageData = imageConfig ? imageConfig(entry) : null;
    const image = imageData && imageData.imageUrl && imageData.altText ? createImageOrLinkedImage(imageData) : null;
    const dateSign = cardType === "list" ? events.sign({
      startMonth: entry.startMonth,
      startDay: entry.startDay,
      endMonth: entry.endMonth,
      endDay: entry.endDay,
      isThemeDark,
      isLargeSize: true
    }) : void 0;
    if (cardType === "list") {
      return card.list({
        headline,
        text,
        eventMeta,
        dateSign,
        image,
        isAligned,
        isThemeDark
      });
    }
    return card.block({
      headline,
      text,
      eventMeta,
      image,
      isAligned,
      isTransparent,
      isThemeDark
    });
  }
};
export {
  eventsDisplayStrategy
};
//# sourceMappingURL=events.js.map
